export default __webpack_public_path__ + "images/212c200ff294906a8cd26d90e5d21427-wtc.png";